import type {
  AllRolesResponse,
  CreateRolesRequest,
  Role,
  RoleResponse,
  RoleWithPermissions,
  RolesRequest,
  UpdateRolesRequest
} from '@library/types/role';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { transformRoleWithPermissions } from '@bo-utils/user';

const { admin } = apiPaths;

export const rolesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRole: build.query<RoleWithPermissions | undefined, { id: string }>({
      query: ({ id }) => ({
        url: `${admin}roles/${id}`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformResponse: (response: RoleResponse) =>
        transformRoleWithPermissions(response.data),
      providesTags: ['Roles']
    }),
    getRoles: build.query<AllRolesResponse, RolesRequest>({
      query: ({ page, perPage }) => ({
        url: `${admin}roles`,
        method: 'GET',
        params: page && perPage ? { page, per_page: perPage } : {},
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      providesTags: ['Roles']
    }),
    createRole: build.mutation<AllRolesResponse, CreateRolesRequest>({
      query: (payload) => ({
        url: `${admin}roles`,
        method: 'POST',
        body: payload,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      invalidatesTags: ['Roles']
    }),
    updateRole: build.mutation<Role, UpdateRolesRequest>({
      query: ({ id, ...payload }) => ({
        url: `${admin}roles/${id}`,
        method: 'PATCH',
        body: payload,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      invalidatesTags: ['Roles']
    })
  })
});

export const {
  useGetRoleQuery,
  useGetRolesQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation
} = rolesApi;
